import React from 'react'

import cleaver from '../../images/CLEAVER.png'

function Cleaver() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={cleaver}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Cleaver</h1>
          <p className="Project-text">
            <strong>
            Short Film
            <br />
New Zealand Film Commission
            <br />

Director: Alex McKenna
            <br />
            2016
            <br />
            <br />

Casting + Rehearsal + On Set Acting Coach
            <br />
Coached supporting actor (age 13)

            </strong>
          </p>
          
          <p className="Project-testimonial">
            "Ella is a great presence to have on set, professional yet comforting, she brought the best performance out of our young cast member.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Alex McKenna, director</strong>
          </h6>
          <br />
          <p className="Project-testimonial">
            "
This was my first film and Ella became my acting coach for what was to be a very demanding role. Leading up to the filming we had multiple sessions in which she helped me greatly get into the role. She used her depth of knowledge from prior acting experiences to give me full confidence for the part. Ella was a very effective, empathetic, friendly, and brilliant acting coach.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~George Baker, actor</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default Cleaver
